import { render, staticRenderFns } from "./AddPoints.vue?vue&type=template&id=f5c219ee&"
import script from "./AddPoints.vue?vue&type=script&lang=js&"
export * from "./AddPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports